"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var addReadWriteRecipient_1 = require("../actions/addReadWriteRecipient");
var maskRecipientFromFindControl_1 = require("../actions/maskRecipientFromFindControl");
var showHideFindResult_1 = require("../actions/showHideFindResult");
var datapoints_1 = require("../datapoints");
var searchDirectory_1 = require("../utils/searchDirectory");
var useTypedAddress_1 = require("../utils/useTypedAddress");
var mobx_react_1 = require("mobx-react");
var Callout_1 = require("office-ui-fabric-react/lib/Callout");
var Utilities_1 = require("office-ui-fabric-react/lib/Utilities");
var owa_analytics_1 = require("owa-analytics");
var FindRecipient_1 = require("owa-recipient-common/lib/components/FindRecipient");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var userAgent_1 = require("owa-user-agent/lib/userAgent");
var React = require("react");
var FindRecipientInfo_1 = require("owa-recipient-common/lib/components/FindRecipientInfo");
var styles = require('./FindRecipientResult.scss');
var classNames = require('classnames/bind').bind(styles);
var FindRecipientResult = /** @class */ (function (_super) {
    tslib_1.__extends(FindRecipientResult, _super);
    function FindRecipientResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dismissFindResult = function () {
            showHideFindResult_1.default(_this.props.recipientWell, false /**shouldShowFindResult */);
        };
        _this.addRecipientAction = function (recipientWell, position) { return function (recipientToAdd) {
            var _a = datapoints_1.default.AddRecipientFromFindControl.datapoint, eventName = _a.name, customData = _a.customData;
            owa_analytics_1.logUsage(eventName, customData(position, recipientWell.findResultType));
            addReadWriteRecipient_1.default(recipientWell, true /* isValid */, recipientToAdd);
        }; };
        _this.maskRecipientAction = function (recipientWell) { return function (recipientToMask) {
            maskRecipientFromFindControl_1.default(recipientWell, recipientToMask);
        }; };
        return _this;
    }
    FindRecipientResult.prototype.render = function () {
        var _this = this;
        var _a = this.props, recipientWell = _a.recipientWell, queryInputGetter = _a.queryInputGetter, findRecipientInfoType = _a.findRecipientInfoType;
        var hasQueryString = !!recipientWell.queryString;
        return recipientWell.shouldShowFindResult ? (React.createElement(Callout_1.Callout, { className: classNames(styles.callout, {
                animationStop: userAgent_1.isBrowserEdge() /* see VSO:13872 Remove on release of RS3 */,
            }), onDismiss: this.dismissFindResult, gapSpace: 10, target: queryInputGetter(), isBeakVisible: false, setInitialFocus: false, directionalHint: Utilities_1.getRTL() ? 6 /* bottomRightEdge */ : 4 /* bottomLeftEdge */ },
            !hasQueryString &&
                recipientWell.findResultSet.length > 0 && (React.createElement("div", { className: styles.suggestedContactsHeaderBox },
                React.createElement("span", { className: styles.suggestedContactsText }, owa_common_strings_1.default.findRecipientResult_SuggestedContactsHeader))),
            recipientWell.findResultSet.length != 0 && (React.createElement("div", { className: classNames(styles.scrollContainer, 'customScrollBar') },
                React.createElement("div", { className: styles.recipientCollection }, recipientWell.findResultSet.map(function (result, index) { return (React.createElement(FindRecipient_1.default, { key: result.EmailAddress.EmailAddress, findRecipient: result, isHighlighted: index == recipientWell.findResultHightlightIndex, addRecipientAction: _this.addRecipientAction(recipientWell, index), maskRecipientAction: _this.maskRecipientAction(recipientWell) })); })))),
            React.createElement(FindRecipientInfo_1.default, { infoType: findRecipientInfoType, highlighted: recipientWell.findResultSet.length ==
                    recipientWell.findResultHightlightIndex, numberOfResults: recipientWell.findResultSet.length, searchDirectoryAction: function () { return searchDirectory_1.default(_this.props.recipientWell); }, useTypedAddressAction: function () { return useTypedAddress_1.default(_this.props.recipientWell); }, queryString: recipientWell.queryString }))) : null;
    };
    FindRecipientResult = tslib_1.__decorate([
        mobx_react_1.observer
    ], FindRecipientResult);
    return FindRecipientResult;
}(React.Component));
exports.default = FindRecipientResult;
//# sourceMappingURL=FindRecipientResult.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/components/FindRecipientResult.js
// module id = 3389
// module chunks = 2 3